import { forwardRef } from "react";
import { useId } from "react";
function SvgRawDecodableFilledIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 5C16.5 5 17 6.66667 17 7.5V10H22V15H24.5C25.3333 15 27 15.5 27 17.5C27 19.5 25.3333 20 24.5 20H22V25H7V20H9.5C10.3333 20 12 19.5 12 17.5C12 15.5 10.3333 15 9.5 15H7V10H12V7.5C12 6.66667 12.5 5 14.5 5Z"
        fill="#1D1D1D"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawDecodableFilledIcon);
export default ForwardRef;
